import React, { useState, useEffect } from "react";
import { useMount, useBoolean } from "ahooks";
import { Modal } from "antd-mobile";
import { useRouteMatch } from 'react-router-dom'
import "./index.css";
import { api } from "../../common/app";
interface State {
	imgs: { img: string }[];
	visibleTime: number;
}

/**
 * 加入全局广告 只执行一次
 */
export default (props: any) => {
	const { showAdvert = true, meetid } = props;
	const initState: State = {
		imgs: [],
		visibleTime: 5,
	};
	const [imgs, setImgs] = useState(initState.imgs);
	const [visibleTime, setVisibleTime] = useState(initState.visibleTime);
	const [visible, { setFalse, toggle }] = useBoolean(false);

	let timer: any;

	const closeModal = () => {
		clearInterval(timer);
		setFalse();
	};

	useEffect(() => {
		if (!!meetid) {
			(api as any).mobileBigScreenAd({ meetid: meetid })
				.then((res: any) => {
					const { result } = res;
					toggle(
						result.is_show === true &&
								showAdvert === true &&
								window.location.href.indexOf("home/index") > -1
					);
					setImgs(result.big);
				});
		}
	}, [showAdvert, meetid]);

	useEffect(() => {
		console.log('visible', visible);
		if (!!visible) {
			timer = setInterval(() => {
				if (visibleTime > 0) {
					setVisibleTime(visibleTime - 1);
				} else {
					closeModal();
				}
			}, 1000);
		}
		return () => clearInterval(timer);
	}, [visible, visibleTime]);
	return (
		<Modal
			visible={visible}
			wrapClassName="advertising"
			style={{
				width: "100vw",
				height: "100vh",
			}}
		>
			<div
				style={{
					width: "100%",
					height: "100%",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "50% 50%",
					backgroundImage: `url(${imgs && imgs[0] && imgs[0].img})`,
				}}
			/>
			<div
				onClick={closeModal}
				style={{
					position: "absolute",
					bottom: 30,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: "100%",
					color: "#fff",
					padding: "10px 0",
				}}
			>
				{`${visibleTime}s后自动关闭`}
			</div>
		</Modal>
	);
};
